export enum DateType {
  DELIVERY = 'DELIVERY',
  RECOVERY = 'RECOVERY',
}
